export const checkCompassAnswers = (data) => {
  for (let key in data) {
    if (data[key] !== '') {
      return true
    }
  }
  return false
}
